import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { TournamentService } from '@/modules/tournament/api/services'
import { TOURNAMENT_QUERY_KEYS } from '@/modules/tournament/constants'
import type { paths } from '@/schema'

type FinalizeTournamentResponse =
	paths['/api/admin/tournaments/{id}/finalize']['post']['responses']['200']['content']['application/json']

const useMutationFinalizeTournament = (id: string) => {
	const queryClient = useQueryClient()

	return useMutation<FinalizeTournamentResponse, Error, void>({
		mutationFn: () => TournamentService.finalizeTournament(id),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: TOURNAMENT_QUERY_KEYS.TOURNAMENTS.ALL,
			})
			toast.success('ประกาศผลและแจกรางวัลสำเร็จ')
		},
		onError: () => {
			toast.error('ประกาศผลและแจกรางวัลล้มเหลว')
		},
	})
}

export default useMutationFinalizeTournament
